import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const quickFilters = css`
  padding: 0 ${pxToRem(spacing.sm)} ${pxToRem(spacing.xs)};
`;
